import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Heading } from './Heading';
import { SwitchInput } from '../../../../../../../common/react/components/SwitchInput';
import {
    seasonSelector,
    roundSelector,
    statsLeadersSortSelector,
    statsLeadersBenchmarkingSelector
} from '../../../../../store/js/modules/statspro/stats-leaders/selectors';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { UPDATE_BENCHMARKING } from '../../../../../store/js/modules/statspro/stats-leaders/actions';

export const StatsLeadersTableHeader = () => {
    const dispatch = useDispatch();
    const sort = useSelector( statsLeadersSortSelector );
    const benchmarking = useSelector( statsLeadersBenchmarkingSelector );
    const season = useSelector( seasonSelector );
    const round = useSelector( roundSelector );

    return (
        <div className="stats-leaders-table-header">

            <Heading { ...{ sort, season, round } } />

            <div className="stats-leaders-table-header__benchmarking-switch">
                <SwitchInput
                    id="benchmarking-toggle"
                    label={ getTranslation( 'label.statsLeaders.benchmarking.toggleText' ).toUpperCase() }
                    isChecked={ benchmarking.isActive }
                    onChange={ isActive => dispatch( UPDATE_BENCHMARKING.request( { isActive } ) ) }
                />
            </div>
        </div>
    );
};
